// Font stacks //
// Utility, Web-safe Fonts
const helvetica = "'Helvetica Neue', Helvetica, Arial, Roboto, sans-serif";
const georgia = "Georgia, 'Times New Roman', serif";

// Gap
// functional
export const gapFont = helvetica;
export const gapFactoryFont = helvetica;

// Banana Republic and Banana Republic Factory Store (BRFS)
const euclid =
  "'EuclidCircularB', 'Hiragino Kaku Gothic Pro', Helvetica, Arial, sans-serif";
const didot = "'Linotype Didot', 'Times New Roman', 'serif'";
const arrowRegular =
  "'TFArrowMedium-Regular', 'Garamond', 'Times New Roman', serif";
//  functional
export const bananaRepublicFactoryFont = euclid;
export const bananaRepublicFont = euclid;
export const bananaRepublicTertiaryFont = didot;
export const bananaRepublicFactoryTertiaryFont = arrowRegular;

// Old Navy
const franklinGothic = `'FranklinGothic', 'Open Sans', ${helvetica}`;
//  functional
export const oldNavyFont = franklinGothic;
export const oldNavyTertiaryFont = franklinGothic;

// Athleta
export const athletaFont = `'Avenir Next', ${helvetica}`;

// Hill City
const superiorTitle = `'Superior Title Light', ${georgia}`;
const avenirNext = `'Avenir Next LT Pro', ${helvetica}`;
// functional
export const hillCityFont = avenirNext;
export const hillCityTertiaryFont = superiorTitle;

// Intermix
export const visuelt = `'Visuelt', ${helvetica}`;
export const miller = `'Miller Headline', ${georgia}`;

// Cross-Brand
const sourceSans = "'Source Sans Pro', Helvetica, Arial, Roboto, sans-serif";
//  functional
export const crossbrandFont = sourceSans;

// Cross-Brand Bright
const monsterrat = `'Monsterrat Regular', ${helvetica}`;
const lora = `'Lora Italic', ${georgia}`;

// functional
export const brightFont = monsterrat;
export const brightFontSecondary = lora;

export const fontSmoothing = {
  WebkitFontSmoothing: "antialiased",
  MozOsxFontSmoothing: "grayscale",
};

export const brightFonts = {
  bright: {
    primary: {
      fontFamily: brightFont,
      fontWeight: 400,
      ...fontSmoothing,
    },
    secondary: {
      fontFamily: brightFontSecondary,
      fontStyle: "italic",
      fontWeight: 300,
      ...fontSmoothing,
    },
  },
};
